import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { CacheService } from "src/app/cache.service";
import { environment } from "src/environments/environment";
import {isLocal} from '../../shared/helpers/local.helper';
import { NS_Enums } from "src/app/shared/namespaces";
import { captureIqSetupFromWindow } from "../../shared/helpers/iq-setup-context.helper";
import {
  clearExplicitLogout,
  isExplicitLogoutPending,
} from "../../shared/helpers/explicit-logout.helper";

@Injectable({
  providedIn: "root",
})
export class RedirectionService {
  constructor(
    private appService: AppService,
    private cacheService: CacheService,
    private router: Router,
    private route: ActivatedRoute,
    private afAuth: AngularFireAuth
  ) {}

  redirectToLogin() {
    // Save the iQ setup deep link before leaving. `UserComponent` calls this from its
    // constructor, so its own ngOnInit capture may never run once the redirect starts, and
    // the global-apps handoff drops `redirectTo`.
    captureIqSetupFromWindow();
    // Local dev only: with a shared `saras_global` cookie, let Daton's own /auth sign in from
    // it (keeping the iQ setup deep link) instead of leaving for the local accounts app.
    if (
      isLocal &&
      !isExplicitLogoutPending() &&
      this.cacheService.getObject<{ token?: string }>(NS_Enums.saras_global)?.token
    ) {
      if (location.pathname.startsWith('/auth') || location.pathname.startsWith('/login')) {
        // AuthComponent is already signing in from the cookie; a stray redirect (e.g. the
        // app.component timer) must not send us to the accounts app mid-verification.
        return;
      }
      this.router.navigate(['/auth'], { queryParamsHandling: 'preserve' });
      return;
    }
    const localUrl = "http://localhost:4200/auth";
    const urlObj = new URL(
      isLocal ? localUrl : environment.PRODUCTS.SARAS
    );
    const usp = new URLSearchParams();
    usp.set(
      "redirectTo",
      isLocal
        ? `${location.origin}${location.pathname}${location.search}`
        : environment.PRODUCTS.DATON
    );
    usp.set("productType", "DATON");
    urlObj.search = usp.toString();
    clearExplicitLogout();
    /* @ts-ignore */
    window.location = urlObj.href;
  }
}
